import { __decorate } from "tslib";
/**
 * 主要用于维护的用户的操作记录，提供Undo和Redo的功能
 */
import _ from 'lodash';
import { Toast } from 'patsnap-biz';
import { injectService, provide } from '@/inversify.config';
import { i18nSymbol } from '@/i18n';
export var userUndoRedoIds;
(function (userUndoRedoIds) {
    userUndoRedoIds["HandsonTableFieldSetting"] = "HandsonTableFieldSetting";
    userUndoRedoIds["CustomFieldsUpdateIndex"] = "CustomFieldsUpdateIndex";
    userUndoRedoIds["TableRowSizeChange"] = "TableRowSizeChange";
    userUndoRedoIds["FieldSettingsUpdate"] = "FieldSettingsUpdate";
    userUndoRedoIds["CustomFieldsUpdate"] = "CustomFieldsUpdate";
})(userUndoRedoIds || (userUndoRedoIds = {}));
const MAX_TASK_STEP_COUNT = 30;
export const UserUndoRedoServiceSymbol = Symbol('UserUndoRedoService');
let UserUndoRedoService = class UserUndoRedoService {
    constructor() {
        this.undoTaskList = [];
        this.redoTaskList = [];
        this.eventsMap = new Map();
        this.i18n = injectService(i18nSymbol);
    }
    addTask(task) {
        // 在undoTaskList数组添加一个元素，如果undoTaskList数组的长度大于30，则删除第一个元素
        if (this.undoTaskList.length >= MAX_TASK_STEP_COUNT) {
            this.undoTaskList.shift();
        }
        task.uuid = _.uniqueId();
        this.undoTaskList.push(task);
        // 清空redoTaskList
        this.redoTaskList = [];
    }
    subscribe(id, callback) {
        this.eventsMap.set(id, callback);
    }
    destroyed() {
        this.clear();
    }
    clear() {
        this.eventsMap.clear();
        this.undoTaskList = [];
        this.redoTaskList = [];
    }
    undo() {
        // 从undoTaskList中获取最后一个元素，然后将其从undoTaskList中删除，并将其添加到redoTaskList中
        const undoTask = this.undoTaskList.pop();
        if (undoTask) {
            this.addRedoTask(undoTask);
            const callback = this.eventsMap.get(undoTask.id);
            callback && callback(undoTask.oldValue, undoTask.newValue, undoTask.uuid);
        }
        else {
            Toast(this.i18n.t('undoAction.undoNoRecords'));
        }
    }
    redo() {
        // 从redoTaskList中获取最后一个元素，然后将其从redoTaskList中删除，并将其添加到undoTaskList中
        const redoTask = this.redoTaskList.pop();
        if (redoTask) {
            this.undoTaskList.push(redoTask);
            const callback = this.eventsMap.get(redoTask.id);
            callback && callback(redoTask.newValue, redoTask.oldValue, redoTask.uuid);
        }
        else {
            Toast(this.i18n.t('undoAction.redoNoRecords'));
        }
    }
    removeTaskByUuid(taskUuid) {
        if (taskUuid) {
            this.undoTaskList = this.undoTaskList.filter(item => item.uuid !== taskUuid);
            this.redoTaskList = this.redoTaskList.filter(item => item.uuid !== taskUuid);
        }
    }
    addRedoTask(task) {
        // 在redoTaskList数组添加一个元素
        if (this.redoTaskList.length >= MAX_TASK_STEP_COUNT) {
            this.redoTaskList.shift();
        }
        this.redoTaskList.push(task);
    }
};
UserUndoRedoService = __decorate([
    provide(UserUndoRedoServiceSymbol)
], UserUndoRedoService);
export { UserUndoRedoService };
